import React from 'react';

import Heading from '@atlaskit/heading/heading';
import Image from '@atlaskit/image';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';

import type { FeatureBlockData, FeatureBlockHeadingLevel } from './types';

export type FeatureBlockProps = FeatureBlockData & {
	/**
	 * The semantic heading level for the block title. Defaults to `h3`.
	 * The visual size is always `small` so the page's heading hierarchy stays
	 * consistent regardless of where the block is rendered.
	 */
	headingLevel?: FeatureBlockHeadingLevel;
};

/**
 * __FeatureBlock__
 *
 * A single block within a `FeatureBlockGrid`. Renders an optional image, a heading,
 * and a description. Not clickable — use `ContentCard` if you need a linked card.
 */
export const FeatureBlock: (props: FeatureBlockProps) => React.JSX.Element = ({
	title,
	description,
	image,
	headingLevel = 'h3',
}) => {
	return (
		<Stack space="space.100">
			{image ? <Image src={image.src} srcDark={image.srcDark} alt={image.alt} /> : null}
			<Heading as={headingLevel} size="small">
				{title}
			</Heading>
			<Text>{description}</Text>
		</Stack>
	);
};
